<template >
  <div>
    <div class="col-lg-12">
      <div class="card shadow mb-4">
          <div class="card-header m-0">
            <div class="row">
              <div class='col col-expand'>
                <h5 class="text-center font-weight-bold">Мэдээлэл</h5>
              </div>
              <div class="col col-auto" v-if="edit && edit==true&&!publicTopic">
                <span class="mr-4" title="Xичээлийг xааx" v-if="lesson.published==true" style="cursor:pointer" @click="setPublished(false,lesson)">
                  <span class="badge badge-success">Нээлттэй</span>
                </span>
              </div>
            </div>
          </div>
          <div class="card-body">
            <p style="margin-bottom: 0rem;" class="h4 text-primary">{{lesson.name}} 
            <span v-if="lesson && lesson.classNos && lesson.classNos.length>0"> - {{lesson.classNos[0]}}</span>
            </p>
            <p class="mb-0 mt-2">
              Багш:
              <span v-if="lesson.teachers">
                  {{lesson.teachers[0].firstName}}
              </span>

              <span v-if="lesson.teachers">
                  / {{lesson.teachers[0].lastName}}
              </span>
              <span style="font-weight:bold">{{lesson.profession}}</span>
            </p>
            <p style="margin-bottom: 0rem;">Xичээлийн код: <span style="font-weight:bold">{{lesson.lectureCode}}, {{lesson.id}}</span></p>
              <vue-qrcode v-if="lesson" :value="lesson.lectureCode.toString()" />
            <!-- <p style="margin-bottom: 0rem;" v-if="lesson.semester">Улирал: <span style="font-weight:bold">{{lesson.semester.id}}</span></p> -->
            <!-- <p style="margin-bottom: 0rem;" v-if="lesson.credit">Кредит: <span style="font-weight:bold">{{lesson.credit}}</span></p> -->
            <!-- <p style="margin-bottom: 0rem;" v-if="lesson.school">Сургууль: <span style="font-weight:bold">{{lesson.school.id}}</span></p>
            <p style="margin-bottom: 0rem;" v-if="lesson.department">Xөтөлбөрийн баг: <span style="font-weight:bold">{{lesson.department.id}}</span></p>
            <p style="margin-bottom: 0rem;" v-if="lesson.program">Хөтөлбөр: <span style="font-weight:bold">{{lesson.program.id}}</span></p> -->
            
          </div>
          <div class="card-footer" v-if="!publicTopic">
            <div class="d-flex" v-if="edit==true">
         
          
          
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-12" v-if="showDetail && showDetail==true">
        <div class="card mb-4 shadow-sm">   
          <div class="card-header row m-0">
            <div class='col'>
              <h5 class="text-center font-weight-bold">Нэмэлт мэдээлэл</h5>
            </div>
          </div>  
          <div class="card-body"> 
            <div class="row  text-center text-lg-left mt-5" v-if="lesson.images!=null && lesson.images.length>0">
              <div class="col-lg-3 col-md-4 col-6" v-for="(file) in lesson.images" v-bind:key="file.fileUrl">
                  <a href="#" class="d-block mb-4 h-100">
                  <img class="img-fluid" :src="file.fileUrl" />
                  </a>
              </div>
            </div>
            <div class="my-4"  v-if="lesson.results!=null && lesson.results.length>0">
              <h5>Зорилго</h5>
              <ul >
                <li v-for="(include) in lesson.results" v-bind:key="include">{{include}}</li>
              </ul>
            </div>
            <div class="my-4" v-if="lesson.requirements!=null && lesson.requirements.length>0">
              <h5>Шаардлагууд</h5>
              <ul >
                <li v-for="(include) in lesson.requirements" v-bind:key="include">{{include}}</li>
              </ul>
            </div>
            <div class="my-4" v-if="lesson.whatlearned!=null && lesson.whatlearned.length>0">
              <h5>Эзэмшүүлэх мэдлэг</h5>
              <ul >
                <li v-for="(include) in lesson.whatlearned" v-bind:key="include">{{include}}</li>
              </ul>
            </div>
            

            <div class="my-4"  v-if="lesson.handlaga!=null && lesson.handlaga.length>0">
              <h5>Хичээлээр эзэмшүүлэх хувь хүний ур чадвар, хандлага</h5>
              <ul >
                <li v-for="(include) in lesson.handlaga" v-bind:key="include">{{include}}</li>
              </ul>
            </div>

          </div>
        </div>
      </div>
  </div>
</template>

<script>
const fb = require('../../../firebaseConfig.js')
import { mapState } from 'vuex'
import moment from 'moment'
import firebase from 'firebase';
import VueQrcode from 'vue-qrcode'


export default {
    name: "LessonInfoPublic",

    data() {
        return {
          lessonLink:'xxxx',
          shareLessonToPublic:null,
          shareLessonToPublicForStudent:null,
          publicTopic:false
        };
    },
    components: {
      VueQrcode,
    },

    methods: {
  
      setPublished(value, lesson){
        if(this.edit && this.edit==true){
          this.setProperty("published", fb.db.doc('schools/'+this.schoolId+"/lessons/"+this.lesson.id), value);
          if(value==true){
            if(lesson.school!=null && lesson.school!=undefined)
              lesson.school.update({"publishedLesson": fb.firestore.FieldValue.increment(1)});
            if(lesson.department!=null && lesson.department!=undefined)
              lesson.department.update({"publishedLesson": fb.firestore.FieldValue.increment(1)});
            if(lesson.program!=null && lesson.program!=undefined)
              lesson.program.update({"publishedLesson": fb.firestore.FieldValue.increment(1)});

            // var publish = firebase.functions().httpsCallable('publishLesson');
            // publish(
            //   { lessonId: lesson.id}
            // );
          }
          else{
            if(lesson.school!=null && lesson.school!=undefined)
              lesson.school.update({"publishedLesson": fb.firestore.FieldValue.increment(-1)});
            if(lesson.department!=null && lesson.department!=undefined)
              lesson.department.update({"publishedLesson": fb.firestore.FieldValue.increment(-1)});
            if(lesson.program!=null && lesson.program!=undefined)
              lesson.program.update({"publishedLesson": fb.firestore.FieldValue.increment(-1)});
            // var unpublish = firebase.functions().httpsCallable('unPublishLesson');
            // unpublish(
            //   { lessonId: lesson.id}
            // );
          }
        }
      },
      // setPropContent(value,topic, item, propertyName){
      //   if(this.lesson!=null && topic!=null && item!=null && propertyName!=null)
      //     this.setProperty(propertyName, fb.db.doc('schools/'+this.schoolId+"/lessons/"+this.lesson.id+"/topics/"+topic.id+"/details/"+item.id), value);
      // },
      setProperty(propertyName, object, value){
        if(object!=null && propertyName!=null){
          var tmp={};
          tmp[propertyName]=value;
          object.update(tmp);
        }
      },
    },

    props: {
      lesson:{
        required:true
      },
      schoolId:{
        required:true
      },
      edit:{
        required:false
      },
      showDetail:{
        required:false
      },
      showDelete:{
        required:false
      },
      // publicTopic:{
      //     required:true
      // }
    },
    created() {
      this.lessonLink='schools/'+this.schoolId+'/slesson/'+this.lesson.id;
      this.shareLessonToPublicLink='schools/'+this.schoolId+'/sharelessontopublic/'+this.lesson.id;
      this.shareLessonToPublicForStudent='sharetopublicforstud/lesson/'+this.lesson.id+'/'+this.schoolId;
      console.log(this.shareLessonToPublicForStudent);
    },
    filters: {
		  formatDate(val) {
          if (!val) { return '-' }
          let date = val.toDate()
          return moment(date).format('MM/DD/YYYY HH:mm');
      },
    }
  
};
</script>

